import { LAYOUT } from '../constants'

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
  {
    path: '/recruitment',
    component: LAYOUT,
    redirect: '/recruitment/companyRecruitment',
    meta: { title: '招聘拓岗', showNavPanel: true },
    children: [
      {
        path: 'companyRecruitment',
        name: '校友企业招聘',
        component: () => import('@/views/recruitment/companyRecruitment.vue'),
        meta: { title: '校友企业招聘' },
      },
      {
        path: 'recruitmentTalk',
        name: '校园宣讲会',
        component: () => import('@/views/recruitment/recruitmentTalk.vue'),
        meta: { title: '校园宣讲会' },
      },
      {
        path: 'faceToFace',
        name: '校园供需见面会',
        component: () => import('@/views/recruitment/faceToFace.vue'),
        meta: { title: '校园供需见面会' },
      },
      {
        path: 'careerFair',
        name: '校园专场招聘会',
        component: () => import('@/views/recruitment/careerFair.vue'),
        meta: { title: '校园专场招聘会' },
      },
      {
        path: 'companyInfo',
        name: '访企拓岗',
        component: () => import('@/views/recruitment/companyInfo.vue'),
        meta: { title: '访企拓岗' },
      },
    ],
  },
]
